import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { InteractiveStyle } from '../layout';
import { mapRoleToTextColor } from '../theme';
import { FontStyle } from '../typography';
import {} from './index';

type TextAlignmentType = 'left' | 'right' | 'center' | 'justify';
type TextRoleType =
  | 'success'
  | 'light'
  | 'primary'
  | 'info'
  | 'error'
  | 'secondary';
type TextStyle =
  | 'heading1'
  | 'heading2'
  | 'heading3'
  | 'primary1'
  | 'primary2'
  | 'default'
  | 'tertiary1'
  | 'tertiary2';
type TextStyleType = 'normal' | 'italic';
type TextType = {
  textRole?: TextRoleType;
  textType?: any;
  align?: TextAlignmentType;
  fontStyle?: TextStyleType;
  underlined?: boolean;
  vertical?: string;
  opacity?: number;
  underline?: boolean;
  nowrap?: boolean;
  ellipsis?: boolean;
};

const TextStyle = css`
  font-family: 'Apercu Pro', 'sans-serif';
  font-style: ${({ fontStyle }) => fontStyle || 'normal'};
  white-space: ${({ nowrap }: any) => nowrap && 'nowrap'};
  text-overflow: ${({ ellipsis }: any) => ellipsis && 'ellipsis'};
  vertical-align: ${({ vertical }) => vertical || 'middle'};
  text-decoration: ${({ underlined }: any) => underlined && 'underline'};
  text-align: ${({ align }) => align || 'center'};
  color: ${({ textRole }) => mapRoleToTextColor(textRole)} !important;
  ${({ textType }: TextType) => {
    return FontStyle[textType] || FontStyle.default;
  }};
`;

export const Text = styled.p<TextType>`
  ${TextStyle}
`;

export const Quote = styled.q<TextType>`
  ${TextStyle}
`;

export const InteractiveText = styled.p<TextType>`
  ${InteractiveStyle}
  ${TextStyle}
    display: flex;
  align-items: center;
  img {
    margin: 0 0 0 4px;
  }
  :hover {
    transition: all 0.15s linear 0s;
    color: ${({ color }: any) => color} !important;
    opacity: ${({ opacity }: any) => opacity};
    text-decoration: ${({ underline }: any) => underline && 'underline'};
  }
`;

export const InteractiveSpan = styled.span<TextType>`
  ${InteractiveStyle}
  ${TextStyle}
    :hover {
    transition: all 0.15s linear 0s;
    color: ${({ color }: any) => color} !important;
    opacity: ${({ opacity }: any) => opacity};
    text-decoration: ${({ underline }: any) => underline && 'underline'};
  }
`;
